module.exports = __webpack_public_path__ + "static/media/4.4 Palamedesz nach klein.241f9ca5.jpg";